<template>
  <div class="about">
    <div class="container">
      <div class="text">
        <h1>
          <span class="hov">A</span>
          <span class="hov">b</span>
          <span class="hov">o</span>
          <span class="hov">u</span>
          <span class="hov">t</span>
        </h1>
        <p>My name is Mikail Thoriq, I'm a Hobbyist programmer and currently studying Computer Science. I'm from Depok, Jawa Barat, Indonesia.</p>
        <p>Well organised person, problem solver, independent with high intention to detail.</p>
        <p>In my works I always try to combine aesthetic with functional aspects, looking for the right balance to communicate without annoying.</p>
        <p></p>
      </div>
      <div class="img">
        <svg
          width="411"
          height="274"
          viewBox="0 0 411 274"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="profile 1">
            <g id="Slice 1">
              <path
                id="Vector"
                d="M401 214.5H20C19.7348 214.5 19.4804 214.395 19.2929 214.207C19.1054 214.02 19 213.765 19 213.5C19 213.235 19.1054 212.98 19.2929 212.793C19.4804 212.605 19.7348 212.5 20 212.5H401C401.265 212.5 401.52 212.605 401.707 212.793C401.895 212.98 402 213.235 402 213.5C402 213.765 401.895 214.02 401.707 214.207C401.52 214.395 401.265 214.5 401 214.5Z"
                fill="#272727"
              />
              <g id="body">
                <path
                  id="Vector 2"
                  d="M192.405 229.826L191.69 217.588L238.556 209.003L239.612 227.067L192.405 229.826Z"
                  fill="#fafafa"
                />
                <path
                  id="Vector 3"
                  d="M194.675 208.641L196.055 232.245L181.194 233.113L178.945 194.648C180.897 194.534 182.852 194.806 184.699 195.447C186.545 196.089 188.248 197.087 189.708 198.387C191.169 199.686 192.359 201.261 193.212 203.02C194.064 204.779 194.561 206.689 194.675 208.641Z"
                  fill="#2F2E41"
                />
                <path
                  id="Vector 4"
                  d="M212.789 229.714L205.004 239.185L164.768 213.666L176.257 199.688L212.789 229.714Z"
                  fill="#fafafa"
                />
                <path
                  id="Vector 5"
                  d="M196.737 243.726L211.751 225.46L223.251 234.913L198.785 264.679C197.275 263.438 196.024 261.911 195.104 260.187C194.184 258.462 193.612 256.573 193.422 254.627C193.232 252.681 193.427 250.717 193.996 248.847C194.564 246.976 195.496 245.236 196.737 243.726Z"
                  fill="#272727"
                />
                <path
                  id="Vector 6"
                  d="M190.387 185.67L185.067 210.749C184.944 211.326 184.951 211.924 185.087 212.498C185.223 213.073 185.484 213.61 185.852 214.072C186.219 214.533 186.685 214.908 187.215 215.168C187.744 215.429 188.325 215.569 188.915 215.578L241.213 216.422C241.803 216.431 242.387 216.31 242.924 216.068C243.462 215.825 243.939 215.467 244.321 215.018C244.704 214.569 244.982 214.042 245.137 213.473C245.292 212.904 245.319 212.308 245.217 211.727L240.642 185.805C240.479 184.879 239.994 184.04 239.274 183.436C238.554 182.831 237.643 182.5 236.703 182.5H194.3C193.383 182.5 192.494 182.815 191.782 183.392C191.069 183.969 190.577 184.773 190.387 185.67Z"
                  fill="#2F2E41"
                />
                <path
                  id="Vector 7"
                  d="M199.059 194.5C199.059 194.5 148.059 162.5 138.059 179.5C133.059 188 135.559 196.25 139.309 202.375C142.789 207.952 147.785 212.423 153.712 215.266L195.059 235.5L210.059 219.5L200.059 210.5L199.059 194.5Z"
                  fill="#272727"
                />
                <path
                  id="Vector 8"
                  d="M225.059 189.5C225.059 189.5 291.059 170.5 278.059 206.5C265.059 242.5 216.059 228.5 216.059 228.5L211.059 213.5L228.059 201.5L225.059 189.5Z"
                  fill="#272727"
                />
                <path
                  id="Vector 9"
                  d="M219.685 193.469C209.479 193.314 199.325 191.977 189.427 189.482L189.135 189.402L175.429 126.357C174.196 120.817 175.035 115.018 177.786 110.054C180.537 105.09 185.011 101.305 190.362 99.4141C206.892 93.4833 224.908 93.1235 241.662 98.3896C247.284 100.201 252.015 104.066 254.913 109.212C257.811 114.358 258.663 120.408 257.297 126.154L241.989 189.35L241.773 189.452C235.411 192.466 227.456 193.469 219.685 193.469Z"
                  fill="#939393"
                />
                <path
                  id="Vector 10"
                  d="M201.274 198.366C201.772 196.983 202.567 195.726 203.603 194.683C204.64 193.64 205.892 192.837 207.272 192.331C208.652 191.824 210.126 191.627 211.591 191.751C213.056 191.876 214.475 192.321 215.75 193.054L242.736 169.63L245.178 188.038L219.177 207.46C217.804 209.519 215.723 211.003 213.328 211.631C210.934 212.258 208.393 211.986 206.186 210.865C203.98 209.744 202.261 207.852 201.355 205.549C200.45 203.245 200.421 200.69 201.274 198.366Z"
                  fill="#fafafa"
                />
                <path
                  id="Vector 11"
                  d="M227.012 203.476C226.573 203.475 226.136 203.411 225.716 203.285C225.033 203.086 224.408 202.727 223.892 202.237C223.377 201.747 222.986 201.141 222.753 200.469L219.496 191.24C219.191 190.387 219.152 189.462 219.385 188.587C219.617 187.711 220.11 186.927 220.798 186.338L257.567 164.264L243.073 99.6025L243.442 99.5137C243.592 99.4766 258.442 96.0967 264.527 112.324C268.789 123.689 284.559 148.401 283.446 165.101C283.235 168.441 281.904 171.612 279.668 174.103C277.432 176.594 274.422 178.259 271.124 178.828L229.736 202.541C228.957 203.145 227.999 203.474 227.012 203.476Z"
                  fill="#939393"
                />
                <path
                  id="Vector 12"
                  d="M231.136 196.173C230.638 194.789 229.843 193.532 228.807 192.489C227.771 191.446 226.519 190.644 225.139 190.137C223.759 189.631 222.284 189.433 220.819 189.558C219.355 189.683 217.935 190.128 216.661 190.86L189.674 167.436L187.233 185.844L213.234 205.267C214.607 207.326 216.688 208.81 219.082 209.437C221.476 210.065 224.017 209.792 226.224 208.671C228.431 207.55 230.15 205.659 231.055 203.355C231.96 201.052 231.989 198.496 231.136 196.173Z"
                  fill="#fafafa"
                />
                <path
                  id="Vector 13"
                  d="M208.106 203.476C207.12 203.474 206.162 203.145 205.382 202.541L160.994 180.828C157.696 180.259 154.686 178.594 152.45 176.103C150.214 173.612 148.883 170.441 148.672 167.101C147.559 150.401 166.329 123.689 170.591 112.324C176.676 96.0967 191.526 99.4756 191.677 99.5137L192.045 99.6026L174.551 166.264L214.32 186.338C215.008 186.927 215.501 187.711 215.733 188.587C215.966 189.462 215.927 190.387 215.622 191.24L212.365 200.469C212.132 201.141 211.741 201.747 211.226 202.237C210.71 202.727 210.085 203.086 209.402 203.285C208.982 203.411 208.545 203.475 208.106 203.476Z"
                  fill="#939393"
                />
                <path
                  id="Vector 14"
                  d="M261.059 213.5H172.059C170.203 213.498 168.424 212.76 167.112 211.447C165.799 210.135 165.061 208.356 165.059 206.5V157.5C165.061 155.644 165.799 153.865 167.112 152.553C168.424 151.24 170.203 150.502 172.059 150.5H261.059C262.915 150.502 264.694 151.24 266.006 152.553C267.319 153.865 268.057 155.644 268.059 157.5V206.5C268.057 208.356 267.319 210.135 266.006 211.447C264.694 212.76 262.915 213.498 261.059 213.5Z"
                  fill="#FAFAFA"
                />
                <path
                  id="Vector 15"
                  d="M216.559 188C219.873 188 222.559 185.314 222.559 182C222.559 178.686 219.873 176 216.559 176C213.245 176 210.559 178.686 210.559 182C210.559 185.314 213.245 188 216.559 188Z"
                  fill="#272727"
                />
              </g>
              <g id="head">
                <path
                  id="Vector 17"
                  d="M241.959 62.6653C241.959 75.6777 231.41 86.2264 218.398 86.2264C205.385 86.2264 194.837 75.6777 194.837 62.6653C194.837 49.6529 205.385 39.1043 218.398 39.1043C231.41 39.1043 241.959 49.6529 241.959 62.6653Z"
                  fill="#FAFAFA"
                  stroke="#272727"
                  stroke-width="2"
                />
                <path
                  id="Vector_2"
                  d="M198.361 33.7621L193.868 31.7605C193.868 31.7605 203.262 20.2514 216.331 21.2522L212.655 16.7486C212.655 16.7486 221.641 12.7454 229.809 23.2537C234.103 28.7777 239.071 35.2709 242.169 42.5853H246.98L244.972 47.5059L252 52.4264L244.786 51.5426C245.216 54.2372 245.282 56.988 244.982 59.7043C244.673 62.4213 243.427 64.8983 241.507 66.6124V66.6124C241.507 66.6124 235.935 53.7779 235.935 51.7763V56.7803C235.935 56.7803 231.443 52.2768 231.443 49.2744L228.992 52.7772L227.767 47.2728L212.655 52.7772L215.106 48.2736L205.712 49.7748L209.388 44.2704C209.388 44.2704 198.769 50.7756 198.361 56.28C197.952 61.7843 194.844 67 194.844 67C194.844 67 186.516 41.268 198.361 33.7621Z"
                  fill="#272727"
                />
              </g>
              <g id="bunga1">
                <path
                  id="Vector 19"
                  d="M51.6626 202.818C52.898 189.513 56.3103 176.501 61.7631 164.301C63.2829 160.906 64.9556 157.586 66.7812 154.34C66.8728 154.171 66.8949 153.972 66.8428 153.786C66.7907 153.601 66.6685 153.443 66.502 153.345C66.3355 153.248 66.1377 153.219 65.9503 153.265C65.7629 153.31 65.6007 153.427 65.4977 153.59C58.8584 165.411 54.2072 178.243 51.7299 191.573C51.0408 195.295 50.5229 199.044 50.1761 202.818C50.088 203.771 51.575 203.765 51.6626 202.818Z"
                  fill="#272727"
                />
                <path
                  id="Vector 20"
                  d="M70.3814 156.724C75.5808 156.724 79.7958 152.509 79.7958 147.31C79.7958 142.111 75.5808 137.896 70.3814 137.896C65.182 137.896 60.967 142.111 60.967 147.31C60.967 152.509 65.182 156.724 70.3814 156.724Z"
                  fill="#272727"
                />
                <path
                  id="Vector 21"
                  d="M52.6257 203.069C53.4272 194.437 55.6409 185.995 59.1784 178.081C60.1643 175.878 61.2495 173.724 62.4339 171.619C62.4932 171.508 62.5075 171.38 62.4737 171.259C62.4399 171.139 62.3606 171.036 62.2526 170.973C62.1446 170.91 62.0163 170.891 61.8948 170.921C61.7733 170.95 61.668 171.026 61.6012 171.132C57.294 178.801 54.2765 187.125 52.6694 195.773C52.2223 198.188 51.8863 200.62 51.6614 203.069C51.6042 203.686 52.5689 203.682 52.6257 203.069Z"
                  fill="#272727"
                />
                <path
                  id="Vector 22"
                  d="M64.7695 173.165C68.1426 173.165 70.877 170.431 70.877 167.058C70.877 163.685 68.1426 160.95 64.7695 160.95C61.3964 160.95 58.6619 163.685 58.6619 167.058C58.6619 170.431 61.3964 173.165 64.7695 173.165Z"
                  fill="#272727"
                />
                <path
                  id="Vector 23"
                  d="M51.4085 202.492C46.7313 195.193 43.2846 187.175 41.206 178.759C40.6288 176.416 40.1596 174.05 39.7984 171.662C39.7776 171.538 39.7096 171.428 39.6088 171.354C39.5081 171.279 39.3824 171.247 39.2584 171.264C39.1344 171.281 39.0217 171.345 38.9441 171.443C38.8665 171.541 38.8301 171.666 38.8425 171.79C40.1631 180.486 42.904 188.906 46.9556 196.713C48.0883 198.892 49.3192 201.016 50.6481 203.085C50.9829 203.607 51.7412 203.011 51.4085 202.492Z"
                  fill="#272727"
                />
                <path
                  id="Vector 24"
                  d="M38.8349 172.736C42.208 172.736 44.9425 170.002 44.9425 166.629C44.9425 163.256 42.208 160.521 38.8349 160.521C35.4618 160.521 32.7273 163.256 32.7273 166.629C32.7273 170.002 35.4618 172.736 38.8349 172.736Z"
                  fill="#272727"
                />
                <path
                  id="Vector 25"
                  d="M32.6587 207.896V195.896C32.66 194.703 33.1346 193.559 33.9782 192.715C34.8218 191.872 35.9656 191.397 37.1587 191.396H65.1587C66.3517 191.397 67.4955 191.872 68.3392 192.715C69.1828 193.559 69.6573 194.703 69.6587 195.896V207.896C69.6573 209.089 69.1828 210.233 68.3392 211.076C67.4955 211.92 66.3517 212.394 65.1587 212.396H37.1587C35.9656 212.394 34.8218 211.92 33.9782 211.076C33.1346 210.233 32.66 209.089 32.6587 207.896Z"
                  fill="#939393"
                />
              </g>
              <g id="clock">
                <path
                  id="Vector_3"
                  d="M340.55 110C354.704 110 366.178 98.5833 366.178 84.5C366.178 70.4167 354.704 59 340.55 59C326.397 59 314.923 70.4167 314.923 84.5C314.923 98.5833 326.397 110 340.55 110Z"
                  fill="#939393"
                />
                <path
                  id="Vector_4"
                  d="M349.481 54.1975C347.161 53.9039 344.812 53.9039 342.492 54.1975C337.322 54.8729 332.456 57.0097 328.47 60.3544C324.484 63.6991 321.547 68.1113 320.006 73.0675C319.305 75.3261 318.908 77.6673 318.825 80.0298C318.813 80.3582 318.806 80.6904 318.806 81.0227C318.813 88.1934 321.679 95.0684 326.775 100.139C331.871 105.209 338.78 108.061 345.987 108.068C346.565 108.068 347.144 108.049 347.714 108.014C349.054 107.93 350.386 107.747 351.698 107.465C357.965 106.124 363.554 102.623 367.479 97.5795C371.403 92.536 373.409 86.2749 373.144 79.902C372.879 73.5292 370.359 67.4546 366.029 62.7512C361.699 58.0478 355.838 55.0182 349.481 54.1975H349.481ZM354.494 105.897H354.49C352.301 106.64 350.023 107.091 347.714 107.237C347.144 107.276 346.565 107.295 345.986 107.295C338.986 107.287 332.275 104.516 327.325 99.5909C322.375 94.6657 319.591 87.9881 319.582 81.0227C319.582 80.6904 319.59 80.3582 319.602 80.0298C319.869 73.2417 322.764 66.8194 327.682 62.1074C332.6 57.3954 339.159 54.759 345.986 54.75C352.242 54.7503 358.294 56.9604 363.065 60.9865C367.836 65.0126 371.015 70.5931 372.036 76.7339C373.058 82.8748 371.855 89.177 368.642 94.5178C365.43 99.8586 360.416 103.891 354.494 105.897H354.494Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_5"
                  d="M346.375 56.2954H345.598V61.7045H346.375V56.2954Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_6"
                  d="M328.689 63.2647L328.139 63.8111L331.983 67.6359L332.532 67.0895L328.689 63.2647Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_7"
                  d="M321.135 80.6364V81.4091H326.571V80.6364H321.135Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_8"
                  d="M328.14 98.2343L328.689 98.7807L332.533 94.9559L331.984 94.4095L328.14 98.2343Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_9"
                  d="M359.44 67.0895L359.99 67.6359L363.833 63.8111L363.284 63.2647L359.44 67.0895Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_10"
                  d="M365.401 80.6364V81.4091H370.838V80.6364H365.401Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_11"
                  d="M359.989 94.4095L359.44 94.9559L363.284 98.7807L363.833 98.2343L359.989 94.4095Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_12"
                  d="M346.375 100.341H345.598V105.75H346.375V100.341Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_13"
                  d="M349.481 47.4091H342.492V54.3636H349.481V47.4091Z"
                  fill="#3F3D56"
                />
                <path
                  id="Vector_14"
                  d="M345.986 48.5682C351.133 48.5682 355.306 47.0978 355.306 45.2841C355.306 43.4703 351.133 42 345.986 42C340.84 42 336.667 43.4703 336.667 45.2841C336.667 47.0978 340.84 48.5682 345.986 48.5682Z"
                  fill="#3F3D56"
                />
                <g id="tick">
                  <path
                    id="Vector_15"
                    d="M347.151 79.4773C346.815 79.2265 346.407 79.0909 345.986 79.0909C345.566 79.0909 345.158 79.2265 344.822 79.4773C344.592 79.6512 344.402 79.8726 344.266 80.1264C344.094 80.4531 344.02 80.8221 344.052 81.1895C344.084 81.557 344.221 81.9077 344.447 82.2002C344.673 82.4927 344.978 82.7147 345.327 82.84C345.676 82.9652 346.053 82.9886 346.415 82.9072C346.776 82.8259 347.107 82.6432 347.367 82.3809C347.628 82.1185 347.808 81.7874 347.885 81.4267C347.963 81.0659 347.935 80.6907 347.805 80.3452C347.675 79.9998 347.448 79.6986 347.151 79.4773H347.151ZM345.986 82.1818C345.678 82.1809 345.382 82.0585 345.164 81.8413C344.946 81.6242 344.823 81.3299 344.822 81.0227C344.823 80.7883 344.895 80.5596 345.027 80.3659C345.141 80.202 345.296 80.07 345.476 79.9828C345.656 79.8955 345.855 79.856 346.055 79.868C346.255 79.88 346.448 79.9431 346.617 80.0512C346.785 80.1593 346.922 80.3088 347.015 80.4852C347.108 80.6615 347.154 80.8588 347.148 81.058C347.142 81.2572 347.085 81.4514 346.982 81.622C346.878 81.7926 346.732 81.9338 346.558 82.0319C346.384 82.1299 346.187 82.1816 345.986 82.1818V82.1818Z"
                    fill="#3F3D56"
                  />
                  <path
                    id="Vector_16"
                    d="M347.151 66.3409H344.822V79.4773H347.151V66.3409Z"
                    fill="#3F3D56"
                  />
                </g>
                <path id="Vector_17" d="M383 106.891H310V107.664H383V106.891Z" fill="#3F3D56" />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped src="../../public/styles/about.css">
</style>